import { IRole } from '@core/interfaces/role.interface';

/**
 * True when `role` grants at least one permission not present in `permissions` - i.e. `role` is
 * strictly broader than whatever `permissions` already covers. Used everywhere a user must be
 * kept from assigning (to themselves or anyone else) a role wider than their own current access:
 * Select Role's per-option disabling, and the Users tab's guard on opening that dialog at all for
 * a row whose current role already exceeds the acting user's own permissions.
 */
export function roleExceedsPermissions(role: IRole, permissions: readonly string[]): boolean {
  return role.permissions.some((permission) => !permissions.includes(permission));
}
